import { http } from '../../../utils';
const controller = 'service-desk/issue-categories';
export const getIssueCategories = async (page, pageSize, orderBy, searchCondition, objectId, issuePriority, status) => {
    return await http.get(controller, {
        params: {
            searchCondition,
            objectId,
            status,
            issuePriority,
            page,
            pageSize,
            orderBy
        }
    });
};
export const getIssueCategory = async (id) => {
    return http.get(`${controller}/${id}`);
};
export const addIssueCategory = async (IssueCategory) => {
    return http.post(controller, IssueCategory);
};
export const updateIssueCategory = async (id, IssueCategory) => {
    return await http.put(`${controller}/${id}`, IssueCategory);
};
export const deleteIssueCategory = async (id) => {
    return await http.delete(`${controller}/${id}`);
};
export const getAllIssueCategory = async (objectId, sequenceDutyIds) => {
    return await http.get(`${controller}/get-all`, {
        params: {
            objectId,
            sequenceDutyIds: sequenceDutyIds
        }
    });
};
export const getIssueCategoriesDropdown = async (issueType, objectTypeId) => {
    return await http.get(`${controller}/dropdown`, {
        params: {
            issueType,
            objectTypeId
        }
    });
};
